import React from 'react';
import Seat from '../../../components/Seat';
import WagonDoor from '../../../components/WagonDoor';
import WagonToilet from '../../../components/WagonToilet';

function FirstFloor({
  seats,
  setChosenSeats,
  chosenSeats,
  wagonNumber,
  reserveSeat,
  unReserveSeat,
}) {
  return (
    <div>
      <div className="wagon">
        <div className="wagon-floor">
          <h2>I</h2>
        </div>
        <WagonDoor
          className="wagon-feature mxp absolute top-1/2 -translate-y-1/2 left-[15px]"
        />
        <div className="seats-row left" style={{ marginLeft: '80px' }}>
          <WagonToilet />
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[37]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[38]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          {[
            [1, 2, 3, 4],
            [5, 6, 7, 8],
            [9, 10, 11, 12],
            [13, 14, 15, 16],
            [17, 18, 19, 20],
            [21, 22, 23, 24],
            [25, 26, 27, 28],
            [29, 30, 31, 32],
            [33, 34, 35, 36],
          ]?.map((fourSeatRow) => (
            <React.Fragment key={fourSeatRow[0]}>
              <div className="seat-column">
                <Seat
                  seat={seats?.[fourSeatRow[1]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
                <Seat
                  seat={seats?.[fourSeatRow[0]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                  bottom
                />
              </div>
              <div className="seat-column reversed ml-2">
                <Seat
                  seat={seats?.[fourSeatRow[2]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
                <Seat
                  seat={seats?.[fourSeatRow[3]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                  bottom
                />
              </div>
            </React.Fragment>
          ))}
          <WagonToilet />
        </div>
      </div>
    </div>
  );
}

export default FirstFloor;
